// react-snap build sırasında sayfaları headless Chrome ile "ReactSnap" user-agent'ıyla render eder.
// Bu sırada dış API istekleri engellenir (skipThirdPartyRequests) → bileşenler hata durumunu
// ("Error / Failed to fetch / 0 node") HTML'e gömüyordu ve Google bunu görüyordu.
// Önceden render'da veri çağrıları yapılmaz: sayfa yükleniyor iskeletiyle kaydedilir, veri tarayıcıda gelir.
export const IS_PRERENDER =
  typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
